import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1976d2' }, // Mira Pro blue
    secondary: { main: '#9c27b0' }, // Mira Pro purple
    background: { 
      default: '#f4f6f8', 
      paper: '#fff' 
    },
    text: { 
      primary: '#222', 
      secondary: '#5c5c5c' 
    },
    divider: '#e0e0e0',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Graphik Webfont", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    fontSize: 12,
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 2px 8px #e3e3e3',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px #e3e3e3',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: 32,
          paddingBottom: 32,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme; 